/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { relative } from 'path'
import { HOUSELINKS } from '../../../data/constants'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    let rootEl = document.getElementById('root') || undefined;
    if(rootEl){
      rootEl.style.height = '100%';
    }
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-root'
    style={{
      height: '100%',
    }}
    >
      <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
        <div id='portal-info' className='d-flex flex-column flex-lg-row-fluid w-lg-30 p-10 order-2 order-lg-1'
        style={{
          position: 'relative',
          backgroundColor: '#1c1c1c',
          backgroundImage: `url(${toAbsoluteUrl('/assets/Crested-Crane.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          color: '#1c1c1c',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        >
        </div>
        <div className='flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        >
          <div className='d-flex flex-center flex-column flex-lg-row-fluid'
          style={{
            height: '90%',
          }}
          >
            <div className='w-lg-500px p-10'>
              <Outlet />
            </div>
          </div>

          <div className='d-flex flex-center flex-wrap px-5'>
              <div className='d-flex fw-semibold text-primary fs-base'>
                <a href={HOUSELINKS.about} target='_blank' className='text-muted text-hover-primary px-2'>
                  About
                </a>

                <a href={HOUSELINKS.support} target='_blank' className='text-muted text-hover-primary px-2'>
                  Support
                </a>

                <a href={HOUSELINKS.legal} target='_blank' className='text-muted text-hover-primary px-2'>
                  Legal
                </a>
              </div>
          </div>
          <div className='d-flex flex-center flex-wrap px-5 mt-3'>
              <div className='d-flex text-muted' style={{
                fontSize: '11px',
              }}>
                  BNIVS is a project of Bank of Uganda & Uganda Bankers’ Association (UBA)
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
